export const DynamicFormRequiredType = {
  False: 0,
  True: 1,
  /**
   * Used by multipart fields, like the textual questionnaire, when part of the field is answered the whole field
   * becomes required.
   */
  Partial: 2,
} as const;
export type DynamicFormRequiredType = (typeof DynamicFormRequiredType)[keyof typeof DynamicFormRequiredType];
